<template>
  <div class="row">
    <div
      :class="
        `col-lg-${
          listFieldsByColumn.length !== 0 ? 12 / listFieldsByColumn.length : 12
        } px-4 mb-4`
      "
      v-for="(columnInput, colIndex) of listFieldsByColumn"
      :key="'row' + colIndex"
    >
      <template v-for="(el, index) of columnInput">
        <template v-if="isItemShow(modelData, el)">
          <TextAreaWithLabel
            v-if="el.type === FORM_TYPE.TEXTAREA"
            :key="'textarea' + colIndex + index"
            :label="el.label"
            :rows="el.rows"
            :description="el.description"
            v-model="modelData[el.model]"
            :submitClicked="submitClicked"
            :isRequired="el.isRequired"
          />
          <CheckboxGroup
            v-else-if="el.type === FORM_TYPE.CHECKBOX"
            :key="'checkbox' + colIndex + index"
            :label="el.label"
            :name="el.model"
            :description="el.description"
            :optionList="el.optionList"
            v-model="modelData[el.model]"
            :submitClicked="submitClicked"
            :isRequired="el.isRequired"
          />
          <RadioGroup
            v-else-if="el.type === FORM_TYPE.RADIO"
            :key="'radio' + colIndex + index"
            :label="el.label"
            :name="el.model"
            :optionList="el.optionList"
            :description="el.description"
            :hasOther="el.hasOther"
            :initialSelection="el.initialSelection"
            :isBooleanModel="el.isBooleanModel"
            v-model="modelData[el.model]"
            :submitClicked="submitClicked"
            :isRequired="el.isRequired"
          />
          <DropdownWithLabel
            v-else-if="el.type === FORM_TYPE.DROPDOWN"
            :key="'dropdown' + colIndex + index"
            :label="el.label"
            :name="el.model"
            :optionList="el.optionList"
            v-model="modelData[el.model]"
            :submitClicked="submitClicked"
            :isRequired="el.isRequired"
          />
          <DatePickerWithLabel
            v-else-if="el.type === FORM_TYPE.DATEPICKER"
            :key="'datepicker' + colIndex + index"
            :label="el.label"
            :initialView="el.initialView"
            :allowPastDate="el.allowPastDate"
            v-model="modelData[el.model]"
            :submitClicked="submitClicked"
            :isRequired="el.isRequired"
          />
          <TextBoxWithLabel
            v-else
            :key="'textbox' + colIndex + index"
            :label="el.label"
            :maxLength="el.maxLength"
            :type="el.inputType"
            :placeholder="el.placeholder"
            :description="el.description"
            :validation="el.validation"
            v-model="modelData[el.model]"
            :submitClicked="submitClicked"
            :isRequired="el.isRequired"
          />
        </template>
      </template>
    </div>
  </div>
</template>
<script>
/* This component is used to show for a list of form (textbox, radio button, checkbox, datepicker ...) 
Elements of form group will be layout into multiple columns*/
import { FORM_TYPE } from "../../constants/custom-define-type";
import TextBoxWithLabel from "./TextBoxWithLabel";
import TextAreaWithLabel from "./TextAreaWithLabel";
import DatePickerWithLabel from "./DatePickerWithLabel";
import RadioGroup from "./RadioGroup";
import DropdownWithLabel from "./DropdownWithLabel";
import CheckboxGroup from "./CheckboxGroup";

export default {
  name: "FormGroupRowLayout",
  components: {
    TextBoxWithLabel,
    TextAreaWithLabel,
    DatePickerWithLabel,
    RadioGroup,
    DropdownWithLabel,
    CheckboxGroup
  },
  props: {
    listFields: {
      type: Array,
      default: () => []
    },
    modelData: Object,
    submitClicked: {
      type: Boolean,
      default: false
    },
    itemPerColumns: Array
  },
  data: function() {
    return {
      FORM_TYPE: FORM_TYPE
    };
  },
  computed: {
    listFieldsByColumn() {
      return this.listFields.reduce((accResult, cur) => {
        if (accResult.length === 0) {
          return [[cur]];
        }
        const lastEl = accResult[accResult.length - 1];
        if (lastEl.length === this.itemPerColumns[accResult.length - 1]) {
          return [...accResult, [cur]];
        }
        accResult[accResult.length - 1].push(cur);
        return accResult;
      }, []);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/FormGroupColumnLayout.vue